export const STOCK_SEARCH = 'STOCK_SEARCH'
export const UPDATE_STOCK_SEARCH_MUT = 'UPDATE_STOCK_SEARCH_MUT'
export const FETCH_PRICE = 'FETCH_PRICE'
export const FILL_HISTORY = 'FILL_HISTORY'
